export default "__VITE_ASSET__DzizZvBo__"